export default "__VITE_ASSET__BiaU3qA9__"